import { useAppDispatch } from "@/store/hooks";
import { ReactNode, useEffect, useState } from "react";
import {
  setUser,
  setSession,
  setState,
  setSteps,
} from "@/store/features/wizardSlice";
import Header from "@/ui/Header";
import Footer from "@/ui/Footer";
import Wizard from "@/components/Wizard";
import { Montserrat } from "next/font/google";
import Spinner from "@/components/shared/Spinner";
import { HubspotUser } from "@/store";

const montserrat = Montserrat({ subsets: ["latin"] });

const Page = ({ children }: { children: ReactNode }) => (
  <div className="w-full h-full bg-academy bg-no-repeat bg-cover">
    <>
      <main
        className={`flex min-h-[calc(100dvh-131px)] sm:min-h-[calc(100dvh-75px)] flex-col max-w-6xl mx-auto p-6 ${montserrat.className}`}
      >
        {children}
      </main>
      <Footer />
    </>
  </div>
);

export default function AppWrapper({
  user,
  session,
  sessionExpired,
  workflow,
}: {
  user: HubspotUser;
  session: any;
  sessionExpired: boolean;
  workflow: any;
}) {
  const [loading, setLoading] = useState(true);

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (user && session && workflow) {
      localStorage.setItem("onboarding_session", session.uuid);
      dispatch(setUser(user));
      console.log("about to dispatch setSession", session);
      dispatch(setSession(session));
      if (workflow.steps) {
        console.log("setSteps", workflow.steps);
        dispatch(setSteps(workflow.steps));
      }
      // else {
      //   console.log(
      //     `OH! we don't have any steps or state to set for workflow ${workflow.id}`,
      //   );
      // }
      if (workflow.state) {
        console.log("setState", workflow.state);
        dispatch(setState(workflow.state));
      }
      //  else {
      // }
    }

    setLoading(false);
  }, [user, session, workflow, dispatch]);

  if (loading) {
    return <Spinner />;
  }

  if (sessionExpired || !user || !user.email) {
    const errorText = sessionExpired
      ? "Your session has expired"
      : "You may have landed here on accident...";

    return (
      <Page>
        <div className="text-center">
          <p className="text-lg">{errorText}</p>
          <p className="text-md hover:underline hover:cursor-pointer">
            Contact Sales
          </p>
        </div>
      </Page>
    );
  }

  return (
    <Page>
      <Header />
      <section className="w-full mt-3 mb-10">
        <Wizard user={user} />
      </section>
    </Page>
  );
}
